import React from "react";

/** Couple's monogram set inside the house's engraved medallion. */
export function Monogram({ left = "A", right = "D", mark = "&", variant = "medallion", size = 92, tone = "default", style }) {
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const line = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 38%, transparent)" : "var(--rule-strong)";
  const letters = (
    <span style={{ display: "inline-flex", alignItems: "center", gap: size * 0.07, fontFamily: "var(--font-title, var(--font-display))", fontWeight: "var(--fw-light)", fontSize: size * 0.34, letterSpacing: "0.04em", lineHeight: 1, color: fg }}>
      <span>{left}</span>
      <span style={{ fontFamily: "var(--font-flourish, var(--font-script))", fontSize: size * 0.3, color: "var(--accent)", transform: "translateY(4%)" }}>{mark}</span>
      <span>{right}</span>
    </span>
  );
  if (variant === "bare") return <div style={{ display: "inline-flex", ...style }}>{letters}</div>;
  return (
    <div style={{ position: "relative", width: size, height: size, display: "grid", placeItems: "center", flex: "none", ...style }}>
      <span style={{ position: "absolute", inset: 0, borderRadius: "50%", border: `1px solid ${line}` }} />
      <span style={{ position: "absolute", inset: size * 0.07, borderRadius: "50%", border: `1px solid ${line}`, opacity: 0.45 }} />
      {letters}
    </div>
  );
}
